import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ModalError } from "@/components/molecules/ModalError";
import useInternetStatus from '@/hooks/useInternetStatus';
import { showModalLoading } from '@/redux/actions/global';
import helpers from '@/utils/helpers';
import { getProductOptions } from '@/utils/product';

const GlobalModalError = () => {
    const { homePath } = getProductOptions()
    const { viewModalError } = useSelector((state) => state.global);
    const [modalErrorData, setModalErrorData] = useState({
        isOpen: false,
        icon: "RideFiErrorLight",
        title: "Ocurrió un error",
        message: "¡Lo sentimos! No pudimos continuar con el proceso que realizabas. Inténtalo nuevamente.",
        buttonText: "Confirmar"
    });

    const isOnline = useInternetStatus();
    const dispatch = useDispatch();

    useEffect(() => {
        if (viewModalError) {
            dispatch(showModalLoading(""));
        }
    }, [viewModalError])

    useEffect(() => {
        if (!isOnline) {
            dispatch(showModalLoading(""));
            helpers.getTagError(
                "07",
                "No hay conexión a internet",
                "trackError"
            )
            setModalErrorData({
                isOpen: true,
                icon: "RideFiConnectionLight",
                title: "No hay conexión a internet",
                message: "Por favor, revisa tu conexión y vuelve a intentarlo.",
                buttonText: "Entendido",
            });
        } else {
            setModalErrorData((prevData) => ({
                ...prevData,
                isOpen: false,
            }));
        }
    }, [isOnline]);

    const handleClickRedirect = () => {
        return window.location.href = homePath;
    };

    return (
        <ModalError
            open={viewModalError || modalErrorData.isOpen}
            icon={modalErrorData.icon}
            title={modalErrorData.title}
            message={modalErrorData.message}
            buttonText={modalErrorData.buttonText}
            onClose={handleClickRedirect}
        />
    )
};

export default GlobalModalError;